/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPolygonAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18.4 22H5.6L1.8 9.6 12 1.7l10.2 7.9L18.4 22zM7.1 20h9.8l3-9.6L12 4.3l-7.8 6.1L7.1 20z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgPolygonAlt as PolygonAlt };
